var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.2495 15C1.70775 15 0 13.2165 0 10.563V4.437C0 1.7835 1.70775 0 4.251 0H10.752C13.293 0 15 1.7835 15 4.437V10.563C15 13.2165 13.293 15 10.752 15H4.2495ZM4.2495 13.875H10.752C12.6488 13.875 13.875 12.5752 13.875 10.563V4.437C13.875 2.42475 12.6488 1.125 10.752 1.125H4.251C2.352 1.125 1.125 2.42475 1.125 4.437V10.563C1.125 12.5752 2.352 13.875 4.2495 13.875ZM7.5045 8.0625C7.194 8.0625 6.942 7.8105 6.942 7.5V4.5C6.942 4.1895 7.194 3.9375 7.5045 3.9375C7.815 3.9375 8.067 4.1895 8.067 4.5V7.5C8.067 7.8105 7.815 8.0625 7.5045 8.0625ZM7.50082 11.0969C7.08607 11.0969 6.75082 10.7617 6.75082 10.3469C6.75082 9.93217 7.08607 9.59692 7.50082 9.59692C7.91558 9.59692 8.25457 9.93217 8.25457 10.3469C8.25457 10.7617 7.92232 11.0969 7.50832 11.0969H7.50082Z",
    fill: "#767676"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.327cc7646f18b5d90e3f022ffb5b3bf9.svg";
export { ForwardRef as ReactComponent };